'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Row = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _RowStyled = require('./styles/RowStyled');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var propTypes = {
  /** Set content flow direction */
  layoutDirection: _propTypes2.default.oneOf(['horizontal', 'vertical']),

  /** Fix row width */
  fixedWidth: _propTypes2.default.bool,

  /**
   * If true, Row will have negative margins to compensate Column gutters
   */
  compensateGutter: _propTypes2.default.bool,

  /** If true, content will wrap */
  wrapContent: _propTypes2.default.bool,

  /**
   * Set size ratio for row
   * @example Row with expandRatio={2} will take twice more size than Row
   * with expandRatio={1}
   */
  expandRatio: _propTypes2.default.number
};
var defaultProps = {
  layoutDirection: 'horizontal',
  compensateGutter: false,
  fixedWidth: false,
  wrapContent: false,
  expandRatio: 0.0
};

var Row = exports.Row = function Row(props) {
  return _react2.default.createElement(_RowStyled.RowStyled, {
    style: {
      flexGrow: props.expandRatio
    },
    layoutDirection: props.layoutDirection,
    compensateGutter: props.compensateGutter,
    fixedWidth: props.fixedWidth,
    wrapContent: props.wrapContent,
    expandRatio: props.expandRatio
  }, props.children);
};

Row.propTypes = propTypes;
Row.defaultProps = defaultProps;
Row.displayName = 'Row';